import { render } from "./form-section.vue?vue&type=template&id=c2875178&ts=true"
import script from "./form-section.vue?vue&type=script&lang=ts"
export * from "./form-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__